/* eslint-disable camelcase */
/* eslint-disable no-new */
import AutoComplete from '../helpers/autocomplete.js';
import { analyticsInit } from '../helpers/analyticsInit.js';
import updateFormValue from '../helpers/formHelpers.js';
import urlParam from '../helpers/urlHelpers.js';

function updateProductInterestFields(e) {
  const selectedInterest = e.target.value;

  const form = window.leadForm;
  const secondaryProductInterestField = 'secondaryProductInterest';

  if (['Site License', ''].includes(selectedInterest)) {
    updateFormValue(form, secondaryProductInterestField, null);
  } else {
    updateFormValue(form, secondaryProductInterestField, selectedInterest);
  }
}

function toggleBusinessRoleDescriptionField(e) {
  const selectedBusinessRole = e.target.value;

  const businessRoleDescriptionFieldEl = document.querySelector(
    '#businessRoleDescriptionField'
  );
  const businessRoleDescriptionInputEl = document.querySelector(
    '#businessRoleDescription'
  );

  if (selectedBusinessRole === 'Other') {
    businessRoleDescriptionFieldEl.removeAttribute('hidden');
    businessRoleDescriptionInputEl.setAttribute('required', true);
  } else {
    businessRoleDescriptionFieldEl.setAttribute('hidden', true);
    businessRoleDescriptionInputEl.removeAttribute('required');
  }
}

function removeNonDigits(e) {
  const inputPhoneNumberValue = e.target.value;
  e.target.value = inputPhoneNumberValue.replace(/[^0-9]/gi, '');
}

function initOrganizationLeadForm() {
  var autoCompleteConfig;

  autoCompleteConfig = {
    elem: document.querySelector('#churchName'),
    resultType: ['church', 'place_of_worship'],
    formMappings: {
      name: 'organizationName',
      street_number: 'organizationAddress',
      route: 'organizationAddress',
      locality: 'organizationCity',
      administrative_area_level_1: 'organizationState',
      postal_code: 'organizationPostalCode',
      phone: 'organizationPhone'
    }
  };

  new AutoComplete(autoCompleteConfig);

  const productInterestSelectEl = document.querySelector(
    '#productInterestSelect'
  );

  if (productInterestSelectEl) {
    productInterestSelectEl.addEventListener(
      'change',
      updateProductInterestFields
    );
  }

  const businessRoleSelectEl = document.querySelector('#businessRole');

  if (businessRoleSelectEl) {
    businessRoleSelectEl.addEventListener(
      'change',
      toggleBusinessRoleDescriptionField
    );
  }

  const phoneNumberEl = document.querySelector('#phone');

  if (phoneNumberEl) {
    phoneNumberEl.addEventListener('blur', removeNonDigits);
    phoneNumberEl.addEventListener('change', removeNonDigits);
  }
}

function updateLeadForm(param) {
  const paramValue = urlParam(param);
  const leadForm = window.leadForm;

  if (paramValue !== null) {
    updateFormValue(leadForm, param, paramValue);
  }
}

analyticsInit();
initOrganizationLeadForm();

updateLeadForm('leadSource');
